export default "__VITE_ASSET__sCjNXCoV__"